import React from "react";

const TableLeft = () => {
  return (
    <div className="container">
      <div className="flex ml-[195px]">
        <div>
          <div className="flex mt-16">
            <img src="images/tabel5.svg" alt="Tabel" className="mr-7 mb-7" />
            <img src="images/tabel1.svg" alt="Tabel" className="mb-7" />
          </div>
          <div className="flex">
            <img src="images/tabel7.svg" alt="Tabel" className="mr-7" />
            <img src="images/tabel2.svg" alt="Tabel" />
          </div>
        </div>
        <div className="mt-16 ml-5">
          <img src="images/shank-tabel.svg" alt="Tabel" />
        </div>
      </div>
      <div className="flex">
        <div className="mt-16">
          <img src="images/tabel20.svg" alt="Tabel" className="mb-12" />

          <img src="images/tabel21.svg" alt="Tabel" className="mb-12" />

          <img src="images/tabel22.svg" alt="Tabel" />
        </div>
        <div className="mt-12 ml-14 mr-[275px]">
          <div className="flex  mr-10">
            <img
              src="images/tabel14.svg"
              alt="Tabel"
              className="mr-14 mb-3.5"
            />
            <img src="images/tabel8.svg" alt="Tabel" className="mb-3.5" />
          </div>
          <div className="flex  mr-10">
            <img
              src="images/tabel15.svg"
              alt="Tabel"
              className="mr-14 mb-3.5"
            />
            <img src="images/tabel10.svg" alt="Tabel" className="mb-3.5" />
          </div>
          <div className="flex  mr-10">
            <img src="images/tabel16.svg" alt="Tabel" className="mr-14" />
            <img src="images/tabel11.svg" alt="Tabel" />
          </div>
          <div className="flex mt-14">
            <img src="images/tabel18.svg" alt="Tabel" className="mr-10" />
            <img src="images/tabel12.svg" alt="Tabel" />
            <img src="images/huti-tabel.svg" alt="Tabel" className="ml-7" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableLeft;
